var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return this.domain.allowCustomNameservers
    ? _c(
        "gg-loading",
        {
          attrs: {
            loading: !!!_vm.domainPopulated,
            type: "table"
          }
        },
        [
          _vm.domainPopulated
            ? _c(
                "div",
                [
                  _c(
                    "gg-card",
                    [
                      _c(
                        "gg-card-header",
                        [
                          _vm._v(" Nameserver Registration "),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mb-2 ml-0 float-right",
                              attrs: {
                                color: "primary",
                                tile: "",
                                depressed: ""
                              },
                              on: {
                                click: function click($event) {
                                  _vm.dialog = true
                                }
                              }
                            },
                            [_vm._v("Add Record")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "gg-card-text",
                        [
                          _c("v-data-table", {
                            attrs: {
                              loading: _vm.table_loading,
                              headers: _vm.ns_table.headers,
                              items: _vm.domain.registered_nameservers,
                              "footer-props": {
                                itemsPerPageOptions: this.pagination
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.actions",
                                  fn: function fn(_ref) {
                                    var item = _ref.item
                                    return [
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            text: "",
                                            loading: _vm.buttons.validate
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.hostValidate(
                                                item.hostname
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Validate")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            text: ""
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.hostEdit(item)
                                            }
                                          }
                                        },
                                        [_vm._v("Edit")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            text: ""
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.openDeleteModal(
                                                item.hostname
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Delete")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1199619347
                            )
                          }),
                          _c("gg-modal", {
                            attrs: {
                              "is-active": _vm.dialog
                            },
                            on: {
                              close: _vm.closeModal
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "toolbar",
                                  fn: function fn() {
                                    return [_vm._v(" Host Record Editor ")]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "body",
                                  fn: function fn() {
                                    return [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("gg-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  outlined: "",
                                                  label: "Host name",
                                                  name: "Host name",
                                                  "error-messages": _vm.errors.collect(
                                                    "Host name"
                                                  ),
                                                  suffix: ".".concat(
                                                    _vm.domain.domain
                                                  )
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.hostname,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "hostname",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.hostname"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("gg-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required|ip",
                                                    expression: "'required|ip'"
                                                  }
                                                ],
                                                attrs: {
                                                  outlined: "",
                                                  label: "IP address",
                                                  name: "IP address",
                                                  "error-messages": _vm.errors.collect(
                                                    "IP address"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.editedItem.ip,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "ip",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editedItem.ip"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "actions",
                                  fn: function fn() {
                                    return [
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            secondary: ""
                                          },
                                          on: {
                                            click: _vm.closeModal
                                          }
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            primary: "",
                                            loading: _vm.buttons.save
                                          },
                                          on: {
                                            click: _vm.saveItem
                                          }
                                        },
                                        [_vm._v("Save")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3353782985
                            )
                          }),
                          _c("gg-modal", {
                            attrs: {
                              "is-active": _vm.delete_dialog
                            },
                            on: {
                              close: _vm.closeDeleteModal
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "toolbar",
                                  fn: function fn() {
                                    return [_vm._v(" Deleting host record ")]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "body",
                                  fn: function fn() {
                                    return [
                                      _vm._v(
                                        " Are you sure you want to delete host record "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.host_for_delete) +
                                            "." +
                                            _vm._s(_vm.domain.domain)
                                        )
                                      ])
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "actions",
                                  fn: function fn() {
                                    return [
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            secondary: ""
                                          },
                                          on: {
                                            click: _vm.closeDeleteModal
                                          }
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            primary: "",
                                            loading: _vm.buttons.delete
                                          },
                                          on: {
                                            click: _vm.hostDelete
                                          }
                                        },
                                        [_vm._v("Delete")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2816707837
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }